import { defineMessages } from 'react-intl'

export const lang = defineMessages({
  payToAddAction: {
    id: 'donater.form.pay_to_add_action',
    defaultMessage: 'add +{value}',
  },
})
